import {
  GridItem,
  DateInputField as CascadiaDateInputField,
} from "@certn/cascadia-react";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { Field } from "formik";

type DateCheckField = components["schemas"]["DateCheckField"];

export function DateInputField({ field: config }: { field: DateCheckField }) {
  return (
    <>
      <GridItem>
        <Field
          name={config.name}
          label={config.label}
          as={CascadiaDateInputField}
          isRequired={config.required}
          testID="birth-details-date-of-birth"
        />
      </GridItem>
    </>
  );
}
